import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { GetProdutosPainelImplantacaoController } from "../../../Controllers/Vendas/PainelImplantacao/PainelImplantacaoControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { IPainelImplantacaoBody } from "../../../Interfaces/Vendas/PainelImplantacao/PainelImplantacaoInterface";
import PainelImplantacaoFiltro from "./FiltroPainelImplantacao";
import ModalDetalheProduto from "./ModalDetalheProduto";
import "./styles.css";

export default function PainelImplantacao() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { filter, setPageFilter } =
        usePaginationFilter<IPainelImplantacaoBody>({
            page: 1,
        });

    const {
        execute: listarProdutosPorUnidade,
        value: ProdutosPorUnidade,
        loading,
    } = useAsyncCallback(GetProdutosPainelImplantacaoController);

    function corDoMarcador(status: string) {
        if (status === "DISPONÍVEL") {
            return "rgb(38, 194, 129)";
        } else if (status === "RESERVADO") {
            return "orange";
        } else if (
            status === "VENDIDO" ||
            status === "FORA VENDA" ||
            status === "SUSPENSO"
        ) {
            return "red";
        }
    }

    function numeroDoLote(produto: string) {
        const splitProduto = produto.split("LT");
        return splitProduto[1];
    }

    function handleSubmitFilter(formData: { ID_EMPREENDIMENTO: number }) {
        setPageFilter({
            filter: formData,
        });

        listarProdutosPorUnidade(formData.ID_EMPREENDIMENTO);
    }

    return (
        <>
            {ProdutosPorUnidade ? (
                <TransformWrapper
                    initialScale={0.35}
                    centerOnInit={true}
                    minScale={0.1}
                >
                    {({
                        zoomIn,
                        zoomOut,
                        resetTransform,
                        centerView,
                        ...rest
                    }) => (
                        <div className="position-relative">
                            <div
                                className="d-flex flex-column position-absolute"
                                style={{ zIndex: 5 }}
                            >
                                <button
                                    className="btn btn-primary font-weight-bold mr-2 mb-1"
                                    onClick={() => zoomIn()}
                                >
                                    +
                                </button>
                                <button
                                    className="btn btn-primary font-weight-bold mr-2 mb-4"
                                    onClick={() => zoomOut()}
                                >
                                    -
                                </button>
                                <button
                                    className="btn btn-primary font-weight-bold mr-2"
                                    onClick={() => centerView()}
                                >
                                    C
                                </button>
                            </div>
                            <div className="w-100 mt-2">
                                <TransformComponent wrapperClass="transformerWrapper">
                                    <div className="position-relative">
                                        <img
                                            style={{
                                                zIndex: 1,
                                                border: "1px solid #000",
                                                resize: "block",
                                            }}
                                            src={`data:image/png;base64, ${ProdutosPorUnidade.IM_MAPA}`}
                                            alt="mapa implantação"
                                        />
                                        {ProdutosPorUnidade.LST_PRODUTOS?.map(
                                            (produto) => (
                                                <div
                                                    onClick={() => {
                                                        setModal({
                                                            Component: () => (
                                                                <ModalDetalheProduto
                                                                    produto={
                                                                        produto
                                                                    }
                                                                    setShow={
                                                                        setShow
                                                                    }
                                                                />
                                                            ),
                                                            IconHeader:
                                                                faCalendar,
                                                            headerComponent:
                                                                "Evento",
                                                            noHeader: true,
                                                            noFooter: true,
                                                            size: "lg",
                                                        });
                                                        setShow(true);
                                                    }}
                                                    style={{
                                                        background:
                                                            corDoMarcador(
                                                                produto.DS_STATUS
                                                            ),
                                                        left:
                                                            produto.VL_IMAGEM_IMPLANTACAO_MARGEM_HORIZONTAL -
                                                            ProdutosPorUnidade.NR_TAMANHO_PIXEL_MAPA /
                                                                2,
                                                        top:
                                                            produto.VL_IMAGEM_IMPLANTACAO_MARGEM_VERTICAL -
                                                            ProdutosPorUnidade.NR_TAMANHO_PIXEL_MAPA /
                                                                2,
                                                        width: ProdutosPorUnidade.NR_TAMANHO_PIXEL_MAPA,
                                                        height: ProdutosPorUnidade.NR_TAMANHO_PIXEL_MAPA,
                                                    }}
                                                    className="marker"
                                                >
                                                    <label className="markerLabel">
                                                        <span
                                                            style={{
                                                                fontSize:
                                                                    ProdutosPorUnidade.NR_TAMANHO_FONTE_MAPA,
                                                            }}
                                                        >
                                                            {numeroDoLote(
                                                                produto.DS_PRODUTO
                                                            )}
                                                        </span>
                                                    </label>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </TransformComponent>
                            </div>
                        </div>
                    )}
                </TransformWrapper>
            ) : (
                <div className="col-12 d-flex justify-content-center">
                    Não existe nenhum mapa de implantação para este
                    empreendimento
                </div>
            )}

            <PainelImplantacaoFiltro
                handleSubmit={handleSubmitFilter}
                defaultFilter={filter}
                inicialyOpenned={!filter && true}
                loading={loading}
            />

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
